import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'acl-favorites-list',
  standalone: false,
  templateUrl: './favorites-list.component.html',
  styleUrl: './favorites-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoritesListComponent {
  private readonly router = inject(Router);

  readonly title = input<string>();
  readonly data = input<any>();

  readonly hasFavorite = computed(() => this.data()?.length > 0);

  navigateInstallation(installation_id: number): void {
    this.router.navigate(['/installation/' + installation_id + '/detail']);
  }
}
